import Endpoint from "../../services/api/endpoint";
import { IContactType } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IContactType>(Endpoint.ContactTypes, Endpoint.ContactTypesList);